<template>
  <div>
    <Table
      border
      :columns="columns12"
      :data="participantList"
      no-data-text="No Participant"
      size="small"
    >
      <template slot-scope="{ row }" slot="name">
        <Button icon="md-list" shape="circle" @click="editParticipantInfo(row)"></Button>
        <span v-if="row.info">
          <b>{{row.info.name}}</b>
        </span>
      </template>
      <template slot-scope="{ row }" slot="notes">
        <span v-if="row.info">{{row.info.notes}}</span>
      </template>
      <template slot-scope="{ row }" slot="createdAt">
        <span v-if="row">{{row.createdAt | moment("HH:mm")}}</span>
      </template>
      <template slot-scope="{ row }" slot="action">
        <Button
          icon="ios-call"
          v-if="connectedParticipantId!=row._id"
          shape="circle"
          @click="connectToOperatorRoom(row)"
        ></Button>
        <Button
          icon="ios-call"
          v-if="connectedParticipantId==row._id"
          shape="circle"
          type="error"
          @click="disconnectToOperatorRoom(row)"
        ></Button>

        <Button
          icon="ios-hand-outline"
          v-if="row.isHandRaised"
          shape="circle"
          type="success"
          @click="lowerHand(row)"
        ></Button>
        <Button
          icon="ios-hand-outline"
          v-if="!row.isHandRaised"
          shape="circle"
          @click="raiseHand(row)"
        ></Button>

        <Button
          icon="ios-mic-off"
          v-if="row.isMuted"
          shape="circle"
          @click="toggleMuteParticipant(row)"
        ></Button>
        <Button
          icon="ios-mic-outline"
          v-if="!row.isMuted"
          shape="circle"
          type="success"
          @click="toggleMuteParticipant(row)"
        ></Button>
        <Button
          icon="ios-pause"
          v-if="!row.isHold"
          shape="circle"
          @click="toggleHoldParticipant(row)"
        ></Button>
        <Button
          icon="ios-pause"
          v-if="row.isHold"
          shape="circle"
          type="error"
          @click="toggleHoldParticipant(row)"
        ></Button>
        <Button icon="ios-close" shape="circle" @click="removeParticipant(row)"></Button>
        <Dropdown style="margin-left:4px;" trigger="click">
          <a href="javascript:void(0)">
            More
            <Icon type="ios-arrow-down"></Icon>
          </a>
          <DropdownMenu slot="list">
            <DropdownItem>
              <span
                type="text"
                v-if="!isSpeakerRoom"
                @click="moveTo(row, audioRoom.speakerPinCode)"
              >Move to speaker room</span>
              <span
                type="text"
                v-if="isSpeakerRoom"
                @click="moveTo(row, audioRoom.pinCode)"
              >Move to participant room</span>
            </DropdownItem>
            <DropdownItem>Block Participant</DropdownItem>
          </DropdownMenu>
        </Dropdown>
      </template>
    </Table>
    <Modal
      v-model="enableNamingForm"
      title="Update Participant"
      @on-ok="updateParticipant(form)"
      @submit.native.prevent
      ok-text="Save"
      width="640"
    >
      <Form :model="form" label-position="top">
        <FormItem label="Name">
          <Input v-model="form.name" placeholder></Input>
        </FormItem>
        <FormItem label="Notes">
          <Input v-model="form.notes" type="textarea" :rows="3" placeholder></Input>
        </FormItem>
      </Form>
      <Button icon="ios-megaphone" shape="circle" @click="listenNameRecording(namingParticipant)"></Button>
    </Modal>
  </div>

  <!--
<div  v-if="isPageReady">
  <div class="container" style="margin-bottom:40px; margin-top: 24px;">
      <div class="list-group webcast-list">
        <div class="list-group-item" v-for="p in participantList.data" :key="p._id" >

          <h4 class="list-group-item-heading">{{p.callerId}} | {{p.info.name}}</h4>
          <p class="list-group-item-text">
            <span>
              Pin Code: {{p.pinCode}}
            </span>
            | onCall: {{p.isOnCall}}
          </p>
          <Button class="p-item-btn"type="primary" shape="circle" icon="ios-call" @click="connectToParticipant(p)"></Button>
          <Button v-if="!p.isMuted" class="p-item-btn" type="success" shape="circle" icon="ios-mic" @click="muteParticipant(p)"></Button>
          <Button v-if="p.isMuted"  class="p-item-btn" type="primary" shape="circle" icon="ios-mic-off" @click="unmuteParticipant(p)"></Button>
        </div>
      </div>
      <Divider/>
  </div>

</div>
  -->
</template>

<script>
import feathersClient from "@/api/feathers-client";
import axios from "axios";
import $config from "@/config";
import { mapState, mapGetters, mapActions } from "vuex";

export default {
  props: ["pinCode"],
  data() {
    return {
      isPageReady: false,
      selected: "all",
      enableNamingForm: false,
      namingParticipant: null,
      connectedParticipant: null,
      isSpeakerRoom: false,
      form: {},
      page: {},
      columns12: [
        {
          title: "Name",
          slot: "name"
        },
        {
          title: "Caller Id",
          key: "callerId",
          maxWidth: 140
        },
        {
          title: "Joined At",
          slot: "createdAt",
          width: 100
        },
        {
          title: "Role",
          key: "role",
          width: 120
        },
        {
          title: "Notes",
          slot: "notes",
          width: 200
        },
        {
          title: " ",
          slot: "action",
          width: 300,
          align: "right"
        }
      ]
    };
  },
  computed: {
    ...mapGetters("audio-participants", {
      findParticipantsInStore: "find"
    }),
    ...mapGetters("audio-room", {
      audioRoom: "getCopy"
    }),
    ...mapGetters("webcast", {
      webcast: "getCopy"
    }),
    participantList() {
      console.log(this.pinCode);
      let query = {
        pinCode: this.pinCode,
        isOnCall: true,
        $sort: {
          handRaisedAt: -1
        }
      };
      console.log(query);
      let participants = this.findParticipantsInStore({
        query: query
      }).data;
      console.log(participants);
      return participants;
    },
    connectedParticipantId() {
      if (this.connectedParticipant) return this.connectedParticipant._id;
      else return null;
    }
  },
  methods: {
    ...mapActions("audio-participants", {
      findParticipantsAction: "find",
      updateParticipantAction: "patch"
    }),
    ...mapActions("audio-room", {
      getAudioRoomAction: "get"
    }),
    toggleMuteParticipant(p) {
      let nextState = true;
      if (p.isMuted) {
        nextState = false;
      } else {
        nextState = true;
      }
      axios
        .post($config.feathersServer + "/audio/toggleMuteParticipant", {
          callSid: p.callSid,
          conferenceSid: p.conferenceSid,
          isMuted: nextState
        })
        .then(res => {
          console.log(res);
        });
    },
    toggleHoldParticipant(p) {
      let nextState = false;
      if (p.isHold) {
        nextState = false;
      } else {
        nextState = true;
      }
      axios
        .post($config.feathersServer + "/audio/toggleHoldParticipant", {
          callSid: p.callSid,
          conferenceSid: p.conferenceSid,
          hold: nextState
        })
        .then(res => {
          this.updateParticipantAction([
            p._id,
            {
              isHold: nextState
            }
          ]).then(res => {
            console.log(res);
          });
        });
    },
    listenNameRecording(p) {
      let audio = new Audio(p.nameRecordingUrl);
      audio.play();
    },
    raiseHand(p) {
      this.updateParticipantAction([
        p._id,
        {
          isHandRaised: true,
          handRaisedAt: Date.now()
        }
      ]).then(res => {
        console.log(res);
      });
    },
    lowerHand(p) {
      this.updateParticipantAction([
        p._id,
        {
          isHandRaised: false,
          handRaisedAt: null
        }
      ]).then(res => {
        console.log(res);
      });
    },
    editParticipantInfo(p) {
      console.log("Editing Participant " + p);
      console.log(p.info);
      this.namingParticipant = p;
      if (p.info) {
        this.form.name = p.info.name;
        this.form.notes = p.info.notes;
      } else {
        this.form = {};
      }
      this.$data.enableNamingForm = true;
    },
    moveTo(p, pinCode) {
      console.log(p);
      axios
        .post($config.feathersServer + "/audio/moveTo", {
          callSid: p.callSid,
          toSpeakerRoom: !this.isSpeakerRoom,
          pinCode: pinCode,
          webcastId: this.webcast._id
        })
        .then(res => {});
    },
    removeParticipant(p) {
      console.log(p);
      axios
        .post($config.feathersServer + "/audio/removeParticipant", {
          callSid: p.callSid,
          pId: p._id,
          conferenceSid: p.conferenceSid
        })
        .then(res => {});
    },
    connectToOperatorRoom(p) {
      //this.enableNamingForm = true;
      this.connectedParticipant = p;
      this.$emit("connectToParticipant", p);
    },
    disconnectToOperatorRoom(p) {
      //this.enableNamingForm = true;
      this.connectedParticipant = null;
      this.$emit("connectToParticipant", null);
    },
    updateParticipant(form) {
      this.updateParticipantAction([
        this.namingParticipant._id,
        {
          info: {
            name: form.name,
            notes: form.notes
          }
        }
      ]).then(res => {
        this.enableNamingForm = false;
      });
    }
  },
  created() {
    //console.log(this.$store.state.auth.user);
    if (this.audioRoom.speakerPinCode == this.pinCode) {
      this.isSpeakerRoom = true;
    }
    this.isPageReady = true;
  },
  mounted() {}
};
</script>

<style lang="less" scoped>
.ivu-table-wrapper {
  border: none !important;
}
.ivu-table-wrapper {
  overflow: visible;
}
.ivu-dropdown-item {
  text-align: left;
}
.ivu-table-cell {
  padding-left: 8px;
  padding-right: 8px;
}
.p-item-btn {
  float: right;
  position: relative;
  top: -40px;
}
.wc-list-filter-wrapper {
  width: 150px;
  float: left;
}
.wc-list-new-btn-wrapper {
  float: right;
}
.wc-list-title {
  width: 300px;
  margin: auto;
}
.ivu-table-cell {
  .ivu-btn {
    margin-right: 4px;
  }
}
</style>
